var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertsLightmode = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9999 60.4216C55.6806 60.4216 60.2857 55.8166 60.2857 50.1359C60.2857 44.4553 55.6806 39.8502 49.9999 39.8502C44.3193 39.8502 39.7142 44.4553 39.7142 50.1359C39.7142 55.8166 44.3193 60.4216 49.9999 60.4216Z",
    fill: "#FC3165"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8861 72.5896C22.9936 73.8959 20.3939 73.2608 19.2894 71.2435C15.818 64.9036 14 57.6895 14 50.1359C14 42.5824 15.818 35.3682 19.2907 29.0284C20.3951 27.0111 22.9936 26.3759 24.8874 27.6822L34.493 34.3088C36.0487 35.3824 36.6131 37.4318 35.7813 39.1289C34.1587 42.4384 33.2857 46.2454 33.2857 50.1359C33.2857 54.0265 34.1587 57.8335 35.78 61.1429C36.6119 62.8414 36.0487 64.8895 34.4917 65.9631L24.8861 72.5896Z",
    fill: "#000433"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1139 72.5896L65.5084 65.9631C63.9527 64.8895 63.3882 62.8401 64.2201 61.1429C65.8414 57.8335 66.7144 54.0265 66.7144 50.1359C66.7144 46.2454 65.8414 42.4384 64.2201 39.1289C63.3882 37.4305 63.9514 35.3824 65.5084 34.3088L75.1139 27.6822C77.0065 26.3759 79.6062 27.0111 80.7107 29.0284C84.1821 35.3682 86.0001 42.5824 86.0001 50.1359C86.0001 57.6895 84.1821 64.9036 80.7094 71.2435C79.6049 73.2608 77.0065 73.8959 75.1139 72.5896Z",
    fill: "#000433"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M86.0002 50.1359C86.0002 57.6831 84.1874 64.9088 80.7159 71.2473C79.6102 73.2659 77.0002 73.8959 75.1102 72.5845L65.5059 65.9631C65.4288 65.9116 65.3516 65.8602 65.2874 65.7959C67.3059 62.8902 71.3045 62.1445 74.2231 64.1631L76.3316 65.6159C78.4531 60.8588 79.5716 55.5616 79.5716 50.1359C79.5716 46.7416 82.2074 43.9516 85.5502 43.7331C85.8459 45.8288 86.0002 47.9631 86.0002 50.1359Z",
    fill: "#000433"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertsLightmode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alerts-lightmode.cf1e906574b4baeafe5aada5c8f1c306.svg";